import type { enAirport } from './en.airport';

export const caAirport: typeof enAirport = {
  airport: {
    mapNames: { airport: 'Aeroport de Taoyuan' },
    zones: { ap_arrivals: 'Sala d’arribades', ap_terminal: 'Terminal 2', ap_gates: 'Portes d’embarcament' },
    objects: {
      ap_mrt: 'Metro de l’aeroport (a Taipei)',
      ap_mrtTaipei: 'Metro de l’aeroport (a l’aeroport)',
      ap_checkin: 'Taulell de facturació',
      ap_info: 'Informació',
      ap_security: 'Control de seguretat',
      ap_gate: 'Porta C7 · Barcelona',
      ap_duty: 'Botiga lliure d’impostos',
      ap_belt: 'Cinta d’equipatges',
      wc_public: 'Lavabo públic',
      rent_shop: 'Lloguer de vehicles',
      bank_counter: 'Banc Llanterna',
      bank_atm: 'Caixer automàtic',
    },
    npc: {},
    items: {},
    texts: {
      mrtToAirport: 'La línia lila del metro va de l’Estació Central de Taipei a l’aeroport de Taoyuan en uns 40 minuts.',
      mrtGo: '🚇 Anar a l’aeroport',
      mrtBack: '🚇 Tornar a Taipei',
      mrtBackText: 'El metro de l’aeroport et torna a l’Estació Central de Taipei.',
      checkin: 'Bon dia! On voles avui? Tingues el passaport a mà, sisplau.',
      checkinAsk: 'Com demanes el bitllet en anglès?',
      ask: ['One ticket to Barcelona, please.', 'Barcelona give ticket me.', 'I want go Barcelona now.'],
      wrong: 'Mmm, torna-ho a provar: pensa en «one ticket to… please».',
      ticket: (price: number) => `✈️ Barcelona — ${price} monedes (anada i tornada)`,
      bought: 'Aquí tens la targeta d’embarcament: porta C7, seient 23A, de finestra. Passa el control de seguretat i segueix els rètols. Bon viatge!',
      poor: (price: number) => `El vol d’anada i tornada a Barcelona val ${price} monedes. Estalvia al banc i torna!`,
      haveTicket: 'Ja tens targeta d’embarcament. Passa el control i ves a la porta C7!',
      tooLate: (h: string) => `L’últim vol a Barcelona surt a les ${h} i avui ja ha marxat. Prova demà al matí.`,
      flown: 'Avui ja has volat. Un gran viatge al dia és suficient!',
      securityText: 'Control de seguretat. Posa la motxilla a la cinta. Què NO pots dur a l’equipatge de mà?',
      securityQ: ['Una ampolla gran d’aigua', 'Un llibre', 'Un entrepà'],
      securityOk: 'Correcte! Els líquids de més de 100 ml es queden fora. Beu-te-la o llença-la… i passa.',
      securityWrong: 'Aquesta no. Pensa: què és líquid i més gran que un got?',
      securityDone: 'Ja has passat el control. La porta C7 és a la dreta.',
      securityNoTicket: 'Targeta d’embarcament, sisplau! Compra el bitllet al taulell primer.',
      gateText: 'Porta C7. El vol BR 67 a Barcelona està embarcant. Unes 14 hores de vol… porta’t un llibre!',
      board: '✈️ Pujar a l’avió',
      needSecurity: 'Has de passar el control de seguretat abans d’embarcar.',
      needTicket: 'Sense targeta d’embarcament? El taulell és a l’esquerra.',
      homeGate: 'Benvingut de nou a Taiwan! Cinta 4 i després el metro a Taipei.',
      info: 'L’aeroport de Taoyuan va obrir el 1979 i és el més gran de Taiwan. Dues terminals, avions a més de 100 ciutats… i una tercera terminal en obres.',
      infoQ: 'Quin és l’aeroport més gran de Taiwan?',
      infoA: ['Taoyuan', 'Songshan', 'Kaohsiung'],
      infoOk: 'Sí! Per Taoyuan passen gairebé tots els vols internacionals.',
      infoWrong: 'No ben bé… és on ets ara mateix!',
      duty: 'Lliure d’impostos: pastissets de pinya, te i mini Taipei 101. Un regal per a algú de casa?',
      dutyBuy: '🍍 Pastissets de pinya (40 monedes)',
      belt: 'Les maletes donen voltes i voltes. La teva és la de l’adhesiu del conillet.',
      flyTo: ['Enlairem sobre les planes verdes de Taoyuan…', 'Núvols a sota, sol a dalt… t’adorms i et despertes, t’adorms i et despertes…', 'Muntanyes! Després el Mediterrani blau… i allà hi ha Barcelona.'],
      flyHome: ['L’avió puja sobre el Mediterrani…', 'Sopar, una peli, una dormida llarga…', 'Muntanyes verdes a sota: Taiwan! Benvingut a casa.'],
      announce: (place: string) => `“Ladies and gentlemen, welcome to ${place}.”`,
      arrive: (place: string) => `Benvingut a ${place}!`,
    },
    hsr: {
      kaohsiung: 'Kaohsiung (alta velocitat)',
      tainan: 'Tainan (alta velocitat)',
      hintKaohsiung: 'la gran ciutat portuària del sud',
      hintTainan: 'la ciutat més antiga, temples i tapes',
      toSouth: ['El tren d’alta velocitat surt de l’estació a 300 km/h…', 'Arrossars i estanys de peixos passen volant per la finestra…', 'Edificis alts al davant: el sud de Taiwan!'],
    },
    wc: { text: 'Un lavabo públic net. Recorda rentar-te les mans!', use: '🚻 Anar al lavabo', wash: '🧼 Només rentar-me les mans' },
    rent: {
      text: 'Lloga un vehicle per a tot el dia! Més ràpid que caminar… i el casc és gratis.',
      bike: '🚲 Bici',
      kick: '🛴 Patinet',
      ebike: '🛵 Moto elèctrica (amb casc)',
      price: (n: number) => `${n} monedes`,
      rented: (what: string) => `Has llogat ${what}. Torna’l a qualsevol botiga de lloguer, o simplement entra en algun lloc.`,
      names: { bike: 'una bici', kick: 'un patinet', ebike: 'una moto elèctrica' },
      ret: '↩️ Tornar el vehicle',
      returned: 'Gràcies! Vehicle tornat.',
      poor: 'No tens prou monedes per a aquest.',
      indoor: 'Deixes el vehicle a la porta: a dins no s’hi circula!',
      helmet: 'Casc posat! A Taiwan tothom el porta a la moto.',
      rule: 'Ves a poc a poc a prop de la gent i mai per la vorera amb la moto.',
    },
    bank: {
      title: '🏦 Banc Llanterna',
      hello: (balance: number, coins: number) => `Benvingut al Banc Llanterna! El teu compte té **${balance}🪙**. A la butxaca: **${coins}🪙**.`,
      atm: (balance: number, coins: number) => `Caixer automàtic. Compte: **${balance}🪙** · butxaca: **${coins}🪙**.`,
      deposit: (n: number) => `⬆️ Ingressar ${n}🪙`,
      depositAll: (n: number) => `⬆️ Ingressar-ho tot (${n}🪙)`,
      withdraw: (n: number) => `⬇️ Treure ${n}🪙`,
      withdrawAll: (n: number) => `⬇️ Treure-ho tot (${n}🪙)`,
      statement: '📄 Moviments',
      goal: '🎯 Objectiu d’estalvi',
      why: '❓ Per què estalviar al banc?',
      whyText: 'Els diners al banc estan segurs i cada matí el banc et paga un **2 % d’interès**: un petit gràcies per deixar-los-hi. Com més estalvies, més creixen!',
      done: (balance: number) => `Fet. El teu compte ara té **${balance}🪙**.`,
      interest: (n: number, balance: number) => `🏦 El banc t’ha pagat ${n}🪙 d’interessos. Saldo: ${balance}🪙.`,
      empty: 'El teu compte és buit. Ingressa unes monedes per començar a guanyar interessos!',
      stmtTitle: 'Últims moviments',
      stmtNone: 'Encara no hi ha moviments.',
      kinds: { in: 'Ingrés', out: 'Retirada', interest: 'Interessos', goal: 'Objectiu assolit' },
      goalText: (goal: number, balance: number) => (goal ? `El teu objectiu: **${goal}🪙**. Tens ${balance}🪙; et falten ${Math.max(0, goal - balance)}.` : 'Encara no tens objectiu. Tria’n un: quan l’assoleixis guanyes estrelles!'),
      goalSet: (n: number) => `🎯 Estalviar ${n}🪙`,
      goalClear: 'Treure l’objectiu',
      goalReached: (n: number) => `🎉 Objectiu assolit: ${n}🪙 estalviades! +5⭐`,
      reward: 'Estalvies per a un vol? Barcelona val 300 monedes.',
      poor: 'No portes tant a la butxaca.',
      poorBank: 'No hi ha tant al compte.',
      payCard: (price: number, pocket: number, missing: number, bank: number) => `Són ${price}🪙 i portes ${pocket}🪙 a la butxaca. Pagues els ${missing}🪙 que falten amb la targeta del banc? (compte: ${bank}🪙)`,
      payCardBtn: (n: number) => `💳 Pagar ${n}🪙 amb el compte`,
      cannotPay: (price: number, pocket: number, bank: number) => `Són ${price}🪙. Portes ${pocket}🪙 a la butxaca i ${bank}🪙 al banc: et falten ${price - pocket - bank}🪙.`,
      wallet: '👛 Moneder',
      potName: 'Banc',
    },
    mapUi: {
      here: '📍 Aquí',
      taiwan: '🗺️ Taiwan',
      goHere: '🧭 Guia’m',
      guiding: (what: string) => `🧭 Et guio fins a: ${what}`,
      pinCleared: 'Has arribat.',
      kinds: { transport: 'Transport', rental: 'Lloguer', toilet: 'Lavabos', bank: 'Banc', food: 'Menjar', shop: 'Botigues', sight: 'Llocs', hotel: 'Hotel', info: 'Informació', door: 'Portes' },
      door: (to: string) => `Porta a ${to}`,
      how: {
        town: 'Casa. Tot comença aquí: l’estació és a l’est del carrer major.',
        taipei: 'Tren des de l’estació (60 monedes). MRT a Ximending, Longshan, Plaça de la Llibertat i Beitou.',
        hualien: 'Tren des de l’estació (90 monedes). Bus turístic a Taroko i Qixingtan.',
        kaohsiung: 'Alta velocitat des de l’estació (150 monedes).',
        tainan: 'Alta velocitat des de l’estació (130 monedes).',
        airport: 'Metro de l’aeroport des de l’Estació Central de Taipei.',
        barcelona: 'Vol des de l’aeroport de Taoyuan (300 monedes, anada i tornada). Facturar, control, porta C7.',
      },
      youAreHere: 'Ets aquí',
      abroad: 'Estranger',
    },
  },
};
